import {SbNavItem} from 'lionheartland';
import {DEFAULT_NAV_ITEMS} from "./nav-items";

export const ALL_NAV_ITEMS = [];

for (const navItem of DEFAULT_NAV_ITEMS) {
  ALL_NAV_ITEMS.push(
      navItem
  )
}